//old import { useCallback, useEffect, useMemo, useState } from "react";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
//old import { KeyRound, Loader2, Info, AlertTriangle, CreditCard } from "lucide-react";
import { KeyRound, Loader2, Info, AlertTriangle, CreditCard, Check } from "lucide-react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import api from "../../api/api";
//old import { Alert, EmptyState, Field, Panel, Pill, Stat, apiError, formatDate, formatMonth, useOrgStyles } from "../../components/org/orgUi";
//old import { Alert, EmptyState, Field, OrgModal, Panel, Pill, Stat, apiError, formatDate, formatMonth, useOrgStyles } from "../../components/org/orgUi";
import { Alert, EmptyState, Field, OrgModal, Panel, Pill, Stat, apiError, formatDate, formatMonth, useOrgStyles, LICENSE_TYPE_LABEL } from "../../components/org/orgUi";
import { useOrgPortal } from "./orgPortalContext";
import { seatPrice, seatTotal } from "../../utils/orgPricing";
import { InviteCode } from "./OrgPrograms";
//old import { EmailText } from "./OrgStudents";
import { EmailText, personName } from "./OrgStudents";
import LicensesModal from "../../components/org/LicensesModal";
import InlineTableSkeleton from "../../components/layout/InlineTableSkeleton";

const money = (n) => `$${Number(n || 0).toFixed(2)}`;
/** Seats bill on the tier's own cycle. */
const perPeriod = (billingMode) => (billingMode === "yearly" ? "per year" : "per month");
/** A price's period the Licenses window's way ("$499.00 a year"), for the lines that say licenses its way too. */
const per = (billingMode) => (billingMode === "yearly" ? "a year" : "a month");

/** Same rule as the backend: the biggest discount step the quantity reaches
 *  applies to every seat. (Also used by Admin → Organizations.) */
export function quote(pricing, qty) {
    let pct = 0;
    (pricing?.Discounts || []).forEach((d) => { if (qty >= d.MinQuantity) pct = d.PercentOff; });
    const each = seatPrice(pricing?.UnitPrice, pct);
    return { pct, each, total: seatTotal(each, qty) };
}
const pctText = (pct) => `${Math.round(Number(pct) * 100) / 100}%`;
/** The Licenses window's way to split a number of licenses ("25 free + 25 paid"): free for a Community
 *  Partner (included for other organizations), added outside the plan, paid on the plan. (Also used by
 *  the Licenses window, so both say it the same way.) */
export function licenseParts(orgType, base, added, paid) {
    const word = orgType === "nonprofit" ? "free" : "included";
    return [`${base} ${word}`, added > 0 ? `${added} added` : null, paid > 0 ? `${paid} paid` : null].filter(Boolean).join(" + ");
}
/** Licenses run by calendar month: a plan that stops renewing keeps its
 *  licenses through the end of the month its paid period ends in.
 *  (Also used by the Overview and Admin → Organizations.) */
export function monthEnd(value) {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return null;
    const last = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0));
    return last.toISOString().slice(0, 10);
}

//old /** A student in the assign dropdown and in license rows: e<RosterEntryID>, or
/** A client in the Licenses table's rows, with a license or without one: e<RosterEntryID>, or
 *  c<ClientID> for a member without a roster entry (and licenses from before codes). */
const studentKey = (x) => (x.RosterEntryID ? `e${x.RosterEntryID}` : `c${x.ClientID}`);
/** Someone saved with a More licenses request ({adminId}, or {rosterEntryId, clientId}) as the table keys a person:
 *  `${type}:${value}`, the way reusable has them. */
const savedPickKey = (type, p) => `${type}:${type === "coach" ? p.adminId : p.rosterEntryId ? `e${p.rosterEntryId}` : `c${p.clientId}`}`;
const studentOptionLabel = (m) => {
    const email = m.Email || m.EmailAddress;
    //old return `${m.LastName}, ${m.FirstName}${m.RosterID ? ` · ${m.RosterID}` : ""}${email ? ` (${email})` : ""}`
    // someone added by email alone (the Overview's Assign a license) has no name yet: their email
    return (m.FirstName || m.LastName ? `${m.LastName}, ${m.FirstName}${m.RosterID ? ` · ${m.RosterID}` : ""}${email ? ` (${email})` : ""}`
        : `${email || ""}${m.RosterID ? ` · ${m.RosterID}` : ""}`)
        + (m.Status === "invited" ? " · not joined yet" : "");
};

const REQUEST_STATUS = {
    pending: { label: "Waiting for approval", tone: "warning" },
    //old approved: { label: "Approved · waiting for payment", tone: "primary" },
    approved: { label: "Ready to pay", tone: "primary" },
    active: { label: "Active", tone: "success" },
    merged: { label: "Added to plan", tone: "success" },
    ended: { label: "Ended", tone: "neutral" },
    rejected: { label: "Declined", tone: "danger" },
    cancelled: { label: "Cancelled", tone: "neutral" },
};
/** Why licenses can't be added to the org's plan now (its PlanChangeBlocked), in the words the backend refuses it
 *  with: the plan keeps what it was bought at until it ends. */
const PLAN_BLOCKED = {
    PRICE_CHANGED: "Your plan's price changed since you bought it",
    BILLING_CHANGED: "Your plan's billing changed since you bought it",
    NO_GROUP_PRICE: "Your plan isn't sold online anymore",
};

/**
 * Monthly seats. A license is valid from the 1st to the end of the month and
 * renews automatically. A removed license's seat stays used until the month
 * ends, so it can't be handed to someone else until the 1st.
 */
export default function OrgLicenses() {
    //old const { orgId, reloadOrg } = useOrgPortal();
    // Only Pono Pilot admins change license counts and renewal (org admins still pay)
    //old const { orgId, reloadOrg, isPlatformAdmin } = useOrgPortal();
    const { orgId, org, reloadOrg, isPlatformAdmin, goTo } = useOrgPortal();
    const s = useOrgStyles();
    const [summary, setSummary] = useState(null);
    const [staff, setStaff] = useState([]);
    const [roster, setRoster] = useState([]);
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);
    //old const [coachPick, setCoachPick] = useState("");
    //old const [studentPick, setStudentPick] = useState("");
    // Picks in the table wait for the one button under it (JJ, Nov 2): who's picked with the Assign button in their row,
    // by person: `${type}:${value}` -> true (value: the AdminID for a coach, e<RosterEntryID> / c<ClientID> for a
    // client, as reusable has them)
    const [picked, setPicked] = useState({});
    // Buy more licenses: the license type whose window is open (its picks are more than the licenses left)
    const [buying, setBuying] = useState(null);
    // Assign licenses clicked with nobody picked: it says where to pick, next to it (it's never greyed out)
    const [nudge, setNudge] = useState(false);
    // Saved picks (a More licenses request's) filled in once the licenses are there, each request once; the ones in
    // the table now are cleared on the server when Assign licenses gives them
    const filled = useRef(new Set());
    const [filledFrom, setFilledFrom] = useState([]);
    const [requests, setRequests] = useState({ pricing: {}, requests: [] });
    const [notice, setNotice] = useState("");
    // Pono Pilot changes the number of licenses in one window (JJ, Oct 23)
    const [licensesOpen, setLicensesOpen] = useState(false);
    // Add to my plan asks first, with what it charges today (the request being added)
    const [adding, setAdding] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();

    const load = useCallback(async () => {
        try {
            const [lic, st, ro] = await Promise.all([
                api.get(`/org/${orgId}/licenses`),
                api.get(`/org/${orgId}/staff`),
                api.get(`/org/${orgId}/roster?sort=alpha`),
            ]);
            setSummary(lic.data);
            setStaff(st.data.staff || []);
            //old setRoster(ro.data.students || []);
            setRoster(ro.data.roster || []);
        } catch (err) {
            setError(apiError(err, "Couldn't load licenses."));
        }
    }, [orgId]);

    // License requests load on their own so the rest of the page still works without them.
    const loadRequests = useCallback(async () => {
        try {
            const res = await api.get(`/org/${orgId}/license-requests`);
            setRequests({ pricing: res.data.pricing || {}, requests: res.data.requests || [] });
        } catch { /* keep the page usable */ }
    }, [orgId]);

    useEffect(() => { load(); loadRequests(); }, [load, loadRequests]);

    // The bar under the table sticks to the bottom of the screen while the table scrolls (below). Sticky sticks inside the
    // nearest box that can scroll, and the app's main is one (overflow-x-hidden) that never scrolls itself (the window does),
    // so the bar wouldn't move: while this page is open, main clips instead, which keeps the page from scrolling sideways all
    // the same without being a box that scrolls (the way a window sets the body's overflow while it's open)
    useEffect(() => {
        const main = document.querySelector("main");
        if (!main) return undefined;
        const before = main.style.overflowX;
        main.style.overflowX = "clip";
        return () => { main.style.overflowX = before; };
    }, []);
    // ...and what Tab moves to isn't left under the stuck bar (review, Nov 2: going down the rows, Tab stopped on Assign
    // buttons it covered, and Space there picked someone nobody could see): while this page is open the window keeps the
    // bar's height clear at its bottom when it scrolls to what's focused (its scroll padding), plus a little for the focus
    // ring; measured whenever the bar changes, since it's taller on a phone and with the line saying where to pick
    const [bar, setBar] = useState(null);
    useEffect(() => {
        const root = document.documentElement;
        if (!bar || !window.ResizeObserver) return undefined;
        const before = root.style.scrollPaddingBottom;
        const fit = new ResizeObserver(() => { root.style.scrollPaddingBottom = `${bar.offsetHeight + 8}px`; });
        fit.observe(bar);
        return () => { fit.disconnect(); root.style.scrollPaddingBottom = before; };
    }, [bar]);

    // The table's order (Alicia, Oct 30: sorting by assigned status; JJ: people pick the order), kept in the URL as the
    // Students page keeps its sort; the default (not assigned first) stays out of it
    const sort = LICENSE_SORTS.some((o) => o.value === searchParams.get("sort")) ? searchParams.get("sort") : "unassigned";
    const setSort = (value) => {
        const next = new URLSearchParams(searchParams);
        if (value === "unassigned") next.delete("sort"); else next.set("sort", value);
        setSearchParams(next, { replace: true });
    };

    // Back from Stripe (?license_session=...): confirm the payment so the seats
    // show up now, even if the webhook hasn't arrived yet.
    useEffect(() => {
        const sessionId = searchParams.get("license_session");
        if (!sessionId) return;
        const next = new URLSearchParams(searchParams);
        next.delete("license_session");
        setSearchParams(next, { replace: true });
        api.post(`/org/${orgId}/license-requests/confirm`, { sessionId })
            .then(() => {
                setNotice("Payment received. Your new licenses are ready to assign.");
                return Promise.all([load(), loadRequests(), reloadOrg()]);
            })
            .catch((err) => setError(apiError(err, "We couldn't confirm the payment yet. Refresh in a minute.")));
    }, [searchParams, setSearchParams, orgId, load, loadRequests, reloadOrg]);


    const licensedCoaches = useMemo(() => new Set((summary?.licenses || []).filter((l) => l.LicenseType === "coach" && l.IsActive).map((l) => l.AdminID)), [summary]);
    //old const licensedStudents = useMemo(() => new Set((summary?.licenses || []).filter((l) => l.LicenseType === "student" && l.IsActive).map((l) => l.ClientID)), [summary]);
    // Someone whose license was removed earlier this month can get it back
    // without a new seat (the backend reuses their seat).
    //old const reusable = useMemo(() => new Set((summary?.licenses || []).filter((l) => !l.IsActive)
    //old     .map((l) => `${l.LicenseType}:${l.AdminID || l.ClientID}`)), [summary]);
    // Student licenses belong to roster entries now (c<ClientID> for a license from before codes)
    const reusable = useMemo(() => new Set((summary?.licenses || []).filter((l) => !l.IsActive)
        .map((l) => (l.LicenseType === "coach" ? `coach:${l.AdminID}` : `student:${studentKey(l)}`))), [summary]);
    const coachOptions = staff.filter((m) => m.IsCoach && !licensedCoaches.has(m.AdminID));
    // A pick as POST /licenses/assign takes it, and who it is (for a message that names them)
    const pickBody = ({ type, value }) => (type === "coach" ? { licenseType: "coach", adminId: Number(value) }
        : value.startsWith("e") ? { licenseType: "student", rosterEntryId: Number(value.slice(1)) }
            : { licenseType: "student", clientId: Number(value.slice(1)) });
    const pickName = (b) => {
        if (b.licenseType === "coach") {
            const m = staff.find((x) => x.AdminID === b.adminId);
            return m ? `${m.FirstName} ${m.LastName}` : "a coach";
        }
        const m = roster.find((x) => (b.rosterEntryId ? x.RosterEntryID === b.rosterEntryId : x.ClientID === b.clientId));
        return m ? personName(m) : "a client";
    };
    //old const studentOptions = roster.filter((m) => !licensedStudents.has(m.ClientID));
    // Everyone on the roster without a license this month, invited or joined
    const studentOptions = roster.filter((m) => !m.HasLicense);

    // Saved picks (Buy more licenses) are filled in once their licenses are there (ready), each request once: everyone
    // saved is picked in their own row, except someone whose removed license comes back with Restore on its own row.
    useEffect(() => {
        const ready = (summary?.savedPicks || []).filter((sp) => sp.ready && !filled.current.has(sp.changeRequestId));
        if (!ready.length) return;
        ready.forEach((sp) => filled.current.add(sp.changeRequestId));
        const next = {};
        ready.forEach((sp) => sp.picks.forEach((p) => {
            const key = savedPickKey(sp.licenseType, p);
            if (!reusable.has(key)) next[key] = true;
        }));
        setPicked((prev) => ({ ...prev, ...next }));
        setFilledFrom((ids) => ids.concat(ready.map((sp) => sp.changeRequestId)));
    }, [summary, reusable]);

    // Returns true when it worked, so a form can stay open (and keep what was
    // typed) when it didn't.
    const act = async (fn) => {
        setBusy(true);
        setError("");
        try {
            await fn();
            await Promise.all([load(), reloadOrg()]);
            return true;
        } catch (err) {
            setError(apiError(err));
            return false;
        } finally {
            setBusy(false);
        }
    };

    //old const assign = (type, id) => act(async () => {
        //old await api.post(`/org/${orgId}/licenses`, type === "coach" ? { licenseType: "coach", adminId: Number(id) } : { licenseType: "student", clientId: Number(id) });
        // Students are picked as e<RosterEntryID>, or c<ClientID> for a member without an entry
        //old await api.post(`/org/${orgId}/licenses`, type === "coach" ? { licenseType: "coach", adminId: Number(id) }
            //old : id.startsWith("e") ? { licenseType: "student", rosterEntryId: Number(id.slice(1)) }
                //old : { licenseType: "student", clientId: Number(id.slice(1)) });
        //old if (type === "coach") setCoachPick(""); else setStudentPick("");
    //old });
    // The table's picks (and Restore) are given in one call, which emails each person their license the way the
    // Overview box does (JJ, Nov 2); savedIds: the More licenses requests whose saved picks are in the table (cleared
    // then). Says who got one and who couldn't, by name; keepPicks: Restore leaves the other picks as they are.
    const assignPicks = async (list, { savedIds = [], keepPicks = false } = {}) => {
        setBusy(true);
        setError("");
        setNotice("");
        try {
            const res = await api.post(`/org/${orgId}/licenses/assign`, { picks: list.map(pickBody), savedPicks: savedIds });
            const { assigned = [], failed = [], emailed = 0 } = res.data;
            const n = assigned.length;
            if (n > 0) {
                setNotice(`Assigned ${n} license${n === 1 ? "" : "s"}.`
                    + (emailed >= n ? (n === 1 ? " We emailed them about it." : " We emailed each of them about theirs.")
                        : emailed > 0 ? ` We emailed ${emailed} of them about theirs.` : ""));
            }
            if (failed.length) {
                setError(`Couldn't assign ${failed.map((f) => `${pickName(f)} (${String(f.error || "").replace(/\.$/, "")})`).join("; ")}.`);
            }
            // (nobody given one, e.g. the licenses ran out meanwhile: the picks stay, and the server keeps the saved ones)
            if (!keepPicks && n > 0) {
                setPicked({});
                setFilledFrom([]);
            }
            await Promise.all([load(), reloadOrg()]);
        } catch (err) {
            setError(apiError(err));
        } finally {
            setBusy(false);
        }
    };

    const requestAct = (fn) => act(async () => { await fn(); await loadRequests(); });
    const createRequest = (kind, quantity, note) => requestAct(async () => {
        await api.post(`/org/${orgId}/license-requests`, { licenseType: kind, quantity, note });
        setNotice("Request sent. You'll be able to pay here once Pono Pilot approves it.");
    });
    const cancelRequest = (req) => {
        //old if (window.confirm(`Cancel your request for ${req.Quantity} ${req.LicenseType} licenses?`)) {
        // (a renewal the org started itself with Renew is its own request: cancelled, not declined)
        if (window.confirm(req.Status === "approved" && !isPlatformAdmin && !req.RenewsRequestID
            //old ? `Decline the ${req.Quantity} ${req.LicenseType} licenses Pono Pilot set up for you? Nothing is charged for them.`
            ? `Decline the ${req.Quantity} ${LICENSE_TYPE_LABEL[req.LicenseType]} licenses Pono Pilot set up for you? Nothing is charged for them.`
            //old : `Cancel your request for ${req.Quantity} ${req.LicenseType} licenses?`)) {
            : `Cancel your request for ${req.Quantity} ${LICENSE_TYPE_LABEL[req.LicenseType]} licenses?`)) {
            requestAct(() => api.delete(`/org/${orgId}/license-requests/${req.RequestID}`));
        }
    };
    const payRequest = async (req) => {
        // Adding to the plan charges the card on it: what it charges today is shown first (Pay now goes to
        // Stripe Checkout, which shows its own amount)
        if (req.AddsToPlan) {
            setError("");
            setAdding(req);
            return;
        }
        setBusy(true);
        setError("");
        try {
            const res = await api.post(`/org/${orgId}/license-requests/${req.RequestID}/checkout`);
            if (res.data.checkoutUrl) {
                window.location.assign(res.data.checkoutUrl);
                return;
            }
            // Added to the existing plan (charged on the card on file), or a
            // checkout that had already gone through was confirmed
            setNotice(res.data.addedToPlan
                //old ? `${req.Quantity} ${req.LicenseType} licenses added to your plan. They're ready to assign.`
                ? `${req.Quantity} ${LICENSE_TYPE_LABEL[req.LicenseType]} licenses added to your plan. They're ready to assign.`
                : "Payment received. Your licenses are ready to assign.");
            await Promise.all([load(), loadRequests(), reloadOrg()]);
        } catch (err) {
            setError(apiError(err, "Couldn't take the payment."));
        }
        setBusy(false);
    };

    // Fewer seats from the next renewal (or back to today's number)
    const changeSeats = (plan, seats) => requestAct(async () => {
        await api.post(`/org/${orgId}/license-requests/${plan.RequestID}/seats`, { seats });
        setNotice(seats === plan.Quantity
            ? "Your plan keeps its current number of licenses."
            : `From ${plan.CurrentPeriodEnd ? formatDate(plan.CurrentPeriodEnd) : "your next renewal"}, your plan has ${seats} licenses.`);
    });

    // An org admin turns its plan's renewal back on in Stripe's portal (Manage billing), where it was stopped
    const openBilling = async (plan) => {
        setBusy(true);
        setError("");
        try {
            const res = await api.post(`/org/${orgId}/license-requests/${plan.RequestID}/billing`);
            window.location.assign(res.data.url);
        } catch (err) {
            setError(apiError(err, "We couldn't open billing. Try again."));
            setBusy(false);
        }
    };
    // Back (the browser's button) from Stripe restores this page as it was: let its buttons work again
    useEffect(() => {
        const restored = (e) => { if (e.persisted) setBusy(false); };
        window.addEventListener("pageshow", restored);
        return () => window.removeEventListener("pageshow", restored);
    }, []);

    const renewRequest = async (req) => {
        setBusy(true);
        setError("");
        try {
            const res = await api.post(`/org/${orgId}/license-requests/${req.RequestID}/renew`);
            if (res.data.checkoutUrl) {
                window.location.assign(res.data.checkoutUrl);
                return;
            }
            setNotice("Renewed. Your licenses carry on next month.");
            await Promise.all([load(), loadRequests(), reloadOrg()]);
        } catch (err) {
            setError(apiError(err, "Couldn't start the renewal."));
        }
        setBusy(false);
    };
    const expiring = requests.requests.filter((r) => r.ExpiresThisMonth);
    // Licenses ending with this month because next month has fewer seats
    const endingLicenses = (summary?.licenses || []).filter((l) => l.IsActive && l.EndPeriod);
    // The org's plan per license type: the active row with automatic payment
    const plans = {
        coach: requests.requests.find((r) => r.LicenseType === "coach" && r.Status === "active" && r.AutoRenews),
        student: requests.requests.find((r) => r.LicenseType === "student" && r.Status === "active" && r.AutoRenews),
    };
    // Licenses added outside the plan (given, or bought without renewal), and this month's split the Licenses
    // window's way: "25 free + 25 paid" (plus any that ended and still count until the month is over)
    const addedOf = (kind) => requests.requests.filter((r) => r.LicenseType === kind && r.Status === "active" && !r.AutoRenews)
        .reduce((n, r) => n + Number(r.Quantity || 0), 0);
    const splitOf = (kind, pool) => {
        const paid = plans[kind] ? Number(plans[kind].Quantity) : 0;
        const ending = pool.purchased - paid - addedOf(kind);
        return licenseParts(org?.OrgType, pool.base, addedOf(kind), paid) + (ending > 0 ? ` + ${ending} ending ${formatDate(summary.periodEnd)}` : "");
    };
    // Stop / restart automatic payment. Stopping keeps the licenses until the
    // paid period ends.
    const setAutoRenew = (req, renew) => {
        const ends = req.CurrentPeriodEnd ? formatDate(monthEnd(req.CurrentPeriodEnd)) : "the end of the paid period";
        const ok = renew || window.confirm(
            //old `Stop renewing ${req.Quantity} ${req.LicenseType} licenses?\n\nYou won't be charged again. You keep the licenses until ${ends}, then they end.`
            `Stop renewing ${req.Quantity} ${LICENSE_TYPE_LABEL[req.LicenseType]} licenses?\n\nYou won't be charged again. You keep the licenses until ${ends}, then they end.`
            + (req.CurrentPeriodEnd ? ` You can turn renewal back on until ${formatDate(req.CurrentPeriodEnd)}.` : ""));
        if (!ok) return;
        requestAct(async () => {
            await api.post(`/org/${orgId}/license-requests/${req.RequestID}/auto-renew`, { renew });
            setNotice(renew ? "Automatic renewal is back on." : `Renewal stopped. The licenses last until ${ends}.`);
        });
    };

    const revoke = (lic) => {
        const ok = window.confirm(
            //old `Remove ${lic.FirstName} ${lic.LastName}'s license?\n\nThey lose access now. The seat stays used until ${formatMonth(summary.nextPeriod)} begins, so it can't go to someone else this month.`
            `Remove ${personName(lic)}'s license?\n\nThey lose access now. The seat stays used until ${formatMonth(summary.nextPeriod)} begins, so it can't go to someone else this month.`
        );
        if (ok) act(() => api.delete(`/org/${orgId}/licenses/${lic.LicenseID}`));
    };

    if (!summary) {
        //old return error ? <Alert>{error}</Alert> : <div className="flex justify-center py-10"><Loader2 className={`animate-spin ${s.muted}`} /></div>;
        // loading: the team's skeleton (the two cards, then the table), as the Impact page does
        return error ? <Alert>{error}</Alert> : (
            <div className="space-y-6" aria-busy="true">
                <div className="grid gap-6 lg:grid-cols-2">
                    {[0, 1].map((i) => <Skeleton key={i} height={220} borderRadius={16}
                                                 baseColor={s.dark ? "#334155" : "#e2e8f0"} highlightColor={s.dark ? "#475569" : "#f1f5f9"} />)}
                </div>
                <InlineTableSkeleton isDarkMode={s.dark} rows={6} cols={6} />
            </div>
        );
    }

    const pools = [
        //old { key: "coach", title: "Coach licenses", pool: summary.coach, options: coachOptions, pick: coachPick, setPick: setCoachPick,
        // (who's picked is in the table's rows now: picked)
        { key: "coach", title: "Coach licenses", pool: summary.coach, options: coachOptions,
          optionLabel: (m) => `${m.FirstName} ${m.LastName}`, optionValue: (m) => m.AdminID,
          emptyHint: "Add coaches under Coaches & Admins first." },
        //old { key: "student", title: "Student licenses", pool: summary.student, options: studentOptions, pick: studentPick, setPick: setStudentPick,
        { key: "student", title: "Client licenses", pool: summary.student, options: studentOptions,
          //old optionLabel: (m) => `${m.LastName}, ${m.FirstName} (${m.EmailAddress})`, optionValue: (m) => m.ClientID,
          optionLabel: studentOptionLabel, optionValue: studentKey,
          emptyHint: "Every student on your roster already has a license." },
    ];
    // Licenses and plans are asked for on the Requests page (Evan, Oct 16)
    const askLink = <button type="button" className={s.btnLink} onClick={() => goTo("requests", { feature: "other" })}>send us a request</button>;
    // Paid licenses that end with this month, per license type: a plan whose renewal is off and whose paid period
    // ends this month (its org admins turn it back on in Manage billing, Pono Pilot with Change licenses),
    // or bought licenses that ended (Renew pays for them again, at today's price)
    const paidEnding = pools.map(({ key, pool }) => {
        const plan = plans[key];
        const planEnds = Boolean(plan?.CancelAtPeriodEnd && plan.CurrentPeriodEnd
            && monthEnd(plan.CurrentPeriodEnd) === String(summary.periodEnd).slice(0, 10));
        // A renewal the org started and didn't pay for (it left Stripe Checkout): the licenses it renews still end
        // this month (they're no longer ExpiresThisMonth), and it's paid below, so the notice stays and points there
        const renewal = requests.requests.find((r) => r.LicenseType === key && r.Status === "approved" && r.RenewsRequestID);
        const renewed = renewal ? requests.requests.filter((r) => r.RequestID === renewal.RenewsRequestID
            && String(r.EndPeriod).slice(0, 10) === String(summary.period).slice(0, 10)) : [];
        const rows = planEnds ? [] : expiring.filter((r) => r.LicenseType === key).concat(renewed);
        if (!planEnds && !rows.length) return null;
        const added = addedOf(key);
        const pricing = requests.pricing[key];
        return {
            kind: key,
            paid: planEnds ? Number(plan.Quantity) : rows.reduce((n, r) => n + Number(r.ScheduledQuantity ?? r.Quantity), 0),
            why: planEnds ? " (renewal is off)" : rows.some((r) => r.Status === "ended") ? " (the automatic payment stopped)" : "",
            //old after: pool.base + added === 0 ? `no ${key} licenses`
            after: pool.base + added === 0 ? `no ${LICENSE_TYPE_LABEL[key]} licenses`
                //old : added > 0 ? `${pool.base + added} ${key} licenses (${licenseParts(org?.OrgType, pool.base, added, 0)})`
                : added > 0 ? `${pool.base + added} ${LICENSE_TYPE_LABEL[key]} licenses (${licenseParts(org?.OrgType, pool.base, added, 0)})`
                    //old : `${pool.base} ${org?.OrgType === "nonprofit" ? "free" : "included"} ${key} licenses`,
                    : `${pool.base} ${org?.OrgType === "nonprofit" ? "free" : "included"} ${LICENSE_TYPE_LABEL[key]} licenses`,
            losing: endingLicenses.filter((l) => l.LicenseType === key).length,
            hint: planEnds && isPlatformAdmin ? <> Turn renewal back on with Change licenses to keep them.</>
                : renewed.length ? (isPlatformAdmin ? <> They carry on once the renewal below is paid.</> : <> To keep them, pay for the renewal below.</>)
                    : !planEnds && !pricing ? <> They can't be renewed online anymore: {askLink} to keep them.</> : null,
            renewals: planEnds
                ? (isPlatformAdmin ? [] : [{ key: plan.RequestID, label: `Renew for ${money(plan.TotalAmount)} ${per(plan.BillingMode)}`, go: () => openBilling(plan) }])
                : !pricing || renewed.length ? [] : rows.map((r) => {
                    const qty = Number(r.ScheduledQuantity ?? r.Quantity);
                    return { key: r.RequestID, label: `Renew${rows.length > 1 ? ` ${qty}` : ""} for ${money(quote(pricing, qty).total)} ${per(pricing.BillingMode)}`,
                        go: () => renewRequest(r) };
                }),
        };
    }).filter(Boolean);
    // Licenses ending this month for another reason (fewer from a renewal, added ones ended)
    const otherEnding = endingLicenses.filter((l) => !paidEnding.some((p) => p.kind === l.LicenseType));
    // Everyone who could get a license and doesn't have one, a row each with a big Assign button (JJ, Nov 2: no lists, a
    // button people just press), whatever the number of licenses left (with none, they're picked and more are bought): the
    // coaches, then the clients on the roster, invited or joined, less anyone whose license removed this month comes back
    // with Restore on its own row. Someone saved with a More licenses request whose licenses aren't there yet (waiting for
    // Build My Biz Brand or for payment) waits for them in their row instead.
    const waiting = new Set((summary.savedPicks || []).filter((sp) => !sp.ready)
        .flatMap((sp) => sp.picks.map((p) => savedPickKey(sp.licenseType, p))));
    const personRows = pools.flatMap(({ key, options, optionValue }) => options
        .map((m) => ({ key: `${key}:${optionValue(m)}`, type: key, value: String(optionValue(m)), license: null, person: m })))
        .filter((r) => !reusable.has(r.key))
        .map((r) => ({ ...r, waiting: waiting.has(r.key) }));
    // The table's rows: every license this month in the backend's order (a removed one keeps its seat until the 1st, so it's
    // a row too), then the people without one; in the chosen order
    const rows = sortLicenseRows(summary.licenses.map((l) => ({ key: `license-${l.LicenseID}`, type: l.LicenseType, license: l }))
        .concat(personRows), sort);
    // (the title counts this month's licenses as before: the ones people have and the ones nobody has yet)
    const licenseCount = summary.licenses.length + pools.reduce((n, { pool }) => n + pool.available, 0);
    // The table's picks (JJ, Nov 2: they wait for the one button under it): the people picked in their rows, not anyone
    // waiting (someone who's gone after a reload, licensed elsewhere or off the roster, takes their pick with them), and per
    // license type how many against the licenses left. More than are left of a type: Buy more licenses (for clients first);
    // otherwise Assign licenses. Only these two (JJ, Nov 2: never greyed out, also with none left), and the count shows each
    // type the organization has licenses of even with nobody picked, so how many are left shows right after Assign licenses too.
    const pickedList = personRows.filter((r) => picked[r.key] && !r.waiting).map(({ type, value }) => ({ type, value }));
    const counts = ["coach", "student"].map((type) => ({ type, n: pickedList.filter((p) => p.type === type).length, left: summary[type].available }))
        .filter((c) => c.n > 0 || summary[c.type].limit > 0);
    const over = counts.filter((c) => c.n > c.left).map((c) => c.type);
    const buyType = over.includes("student") ? "student" : over[0] || null;
    const people = (n) => `${n} ${n === 1 ? "person" : "people"}`;
    const assignAll = () => {
        if (!pickedList.length) {
            setNudge(true);
            return;
        }
        if (window.confirm(`Assign licenses to ${people(pickedList.length)}?\n\nEach of them gets an email about their license, with their `
            + "link to join (or to sign in, if it's already on their account).")) {
            assignPicks(pickedList, { savedIds: filledFrom });
        }
    };
    // Licenses left with nobody to give them to: why is said once, above the table (review, Nov 2: not a cut-off sentence
    // in every row): no coaches yet, nobody on the roster yet, or everyone on it has a license already
    const nobodyLines = pools.filter(({ pool, options }) => pool.available > 0 && options.length === 0)
        .map(({ key, emptyHint }) => ({ key: `nobody-${key}`, text: key === "coach" ? emptyHint
            : roster.length === 0 ? "Add clients on the Clients page first." : "Every client on your roster already has a license." }));
    // What happened to the picks saved with a More licenses request: waiting for Build My Biz Brand, set up and waiting
    // for payment (their people wait in their rows), or filled in below, picked in their rows (with a line for each person
    // who couldn't be)
    const savedLines = (summary.savedPicks || []).flatMap((sp) => {
        const label = LICENSE_TYPE_LABEL[sp.licenseType];
        const n = sp.picks.length + sp.dropped.length;
        const they = `The ${people(n)} you picked ${n === 1 ? "is" : "are"}`;
        if (sp.status === "pending") {
            return [{ key: `wait-${sp.changeRequestId}`, text: `Waiting for Pono Pilot: ${sp.quantity} more ${label} licenses. ${they} saved and filled in here once they're added.` }];
        }
        if (!sp.ready) {
            return [{ key: `pay-${sp.changeRequestId}`, text: `Pono Pilot set up ${sp.quantity} more ${label} licenses for you: pay for them above. ${they} filled in here once they're added.` }];
        }
        if (!filledFrom.includes(sp.changeRequestId)) return [];
        return (sp.picks.length ? [{ key: `filled-${sp.changeRequestId}`, text: `The ${people(sp.picks.length)} you picked when you asked for more ${label} licenses `
            + `${sp.picks.length === 1 ? "is" : "are"} filled in below. Check them, then click Assign licenses.` }] : [])
            .concat(sp.dropped.map((d, i) => ({ key: `dropped-${sp.changeRequestId}-${i}`, warn: true,
                text: d.reason === "licensed" ? `${personName(d)} already has a license this month.`
                    : sp.licenseType === "coach" ? `${personName(d)} isn't one of your coaches anymore, so they weren't filled in.`
                        : `${personName(d)} isn't on your roster anymore, so they weren't filled in.` })));
    });
    // A More licenses request was sent: its picks are saved with it, so they're no longer picked here (their people wait
    // for its licenses)
    const onRequestSent = async (kind, quantity) => {
        setBuying(null);
        setPicked((prev) => Object.fromEntries(Object.entries(prev).filter(([k]) => !k.startsWith(`${kind}:`))));
        setError("");
        setNotice(`Request sent for ${quantity} more ${LICENSE_TYPE_LABEL[kind]} licenses. You can follow it on your Requests page.`);
        await load();
    };

    return (
        <div className="space-y-6">
            <Alert onClose={() => setError("")}>{error}</Alert>
            <Alert kind="success" onClose={() => setNotice("")}>{notice}</Alert>
            {/* old {endingLicenses.length > 0 && ( */}
            {/* (paid licenses ending have their own notice below; only Pono Pilot adds licenses, Alicia, Oct 2) */}
            {otherEnding.length > 0 && (
                <div role="status" className={`flex items-start gap-2 rounded-2xl border p-4 text-sm ${s.dark ? "border-amber-800 bg-amber-900/20" : "border-amber-200 bg-amber-50"}`}>
                    <AlertTriangle size={18} className="mt-0.5 flex-shrink-0 text-amber-500" />
                    <p className={s.text}>
                        {/* old <strong>{endingLicenses.length} license{endingLicenses.length === 1 ? "" : "s"}</strong> end on <strong>{formatDate(summary.periodEnd)}</strong> because */}
                        {/* old you'll have fewer licenses next month (marked below). To keep {endingLicenses.length === 1 ? "it" : "them"}, renew or get more licenses, */}
                        {/* old or remove someone else: the freed license goes back to them. */}
                        <strong>{otherEnding.length} license{otherEnding.length === 1 ? "" : "s"}</strong> end{otherEnding.length === 1 ? "s" : ""} on <strong>{formatDate(summary.periodEnd)}</strong> because
                        you'll have fewer licenses next month (marked below). To keep {otherEnding.length === 1 ? "it" : "them"},{" "}
                        {isPlatformAdmin ? "add licenses with Change licenses" : askLink}, or remove someone else: the freed license goes back to them.
                    </p>
                </div>
            )}
            {/* old {expiring.map((r) => ( */}
            {/* Paid licenses ending this month: one notice per license type (Alicia, Oct 2: an expiring-soon indicator) saying
                when, what's left after and who loses one, with the price on its button (Jul 20: the price before paying) */}
            {paidEnding.map((p) => (
                //old <div key={r.RequestID} role="status"
                <div key={p.kind} role="status"
                     className={`flex flex-col gap-3 rounded-2xl border p-4 text-sm sm:flex-row sm:items-center sm:justify-between ${s.dark ? "border-amber-800 bg-amber-900/20" : "border-amber-200 bg-amber-50"}`}>
                    <p className={`flex items-start gap-2 ${s.text}`}>
                        <AlertTriangle size={18} className="mt-0.5 flex-shrink-0 text-amber-500" />
                        <span>
                            {/* old The <strong>{r.ScheduledQuantity ?? r.Quantity} {r.LicenseType} licenses</strong> you bought end on <strong>{formatDate(r.PeriodEnd)}</strong>. */}
                            {/* old {" "}Renew to keep them next month{r.Status === "ended" ? " (the automatic payment stopped)" : ""}. */}
                            {/* old Your <strong>{p.paid} paid {p.kind} licenses</strong> end on <strong>{formatDate(summary.periodEnd)}</strong>{p.why}. */}
                            Your <strong>{p.paid} paid {LICENSE_TYPE_LABEL[p.kind]} licenses</strong> end on <strong>{formatDate(summary.periodEnd)}</strong>{p.why}.
                            {" "}After that you have {p.after}
                            {p.losing > 0 && (p.losing === 1 ? "; the person marked below loses theirs" : `; the ${p.losing} people marked below lose theirs`)}.
                            {p.hint}
                        </span>
                    </p>
                    {/* old <button type="button" className={s.btnPrimary} disabled={busy} onClick={() => renewRequest(r)}> */}
                    {/* old <CreditCard size={14} /> Renew */}
                    {/* old </button> */}
                    {p.renewals.length > 0 && (
                        <span className="flex flex-shrink-0 flex-wrap gap-2">
                            {p.renewals.map((rn) => (
                                <button key={rn.key} type="button" className={s.btnPrimary} disabled={busy} onClick={rn.go}>
                                    <CreditCard size={14} /> {rn.label}
                                </button>
                            ))}
                        </span>
                    )}
                </div>
            ))}
            <div className={`flex items-start gap-3 rounded-2xl border p-4 text-sm ${s.subPanel}`}>
                <Info size={18} className={`mt-0.5 flex-shrink-0 ${s.muted}`} />
                <p className={s.body}>
                    {/* old <strong className={s.text}>{formatMonth(summary.period)}</strong>: licenses run through {formatDate(summary.periodEnd)} and renew automatically. */}
                    {/* old A license you remove can't be given to someone else until {formatDate(summary.nextPeriod)}. */}
                    {/* (Alicia, Oct 2: a license runs from the 1st to the last day of a month and sits with its person until removed; 'renew' is for payments) */}
                    <strong className={s.text}>{formatMonth(summary.period)}</strong>: licenses run from the 1st to the last day of the month and stay with
                    each person until you remove them (or you have fewer licenses next month). A license you remove can't go to someone else
                    until {formatDate(summary.nextPeriod)}.
                </p>
            </div>

            <div className="grid gap-6 lg:grid-cols-2">
                {/* old {pools.map(({ key, title, pool, options, pick, setPick, optionLabel, optionValue, emptyHint }) => ( */}
                {pools.map(({ key, title, pool }) => (
                    <Panel key={key} title={title}>
                        <div className="grid grid-cols-3 gap-3">
                            {/* old <Stat label="Assignments this month" value={`${pool.used} / ${pool.limit}`} tone={pool.limit > 0 && pool.available === 0 ? "warn" : "default"} */}
                            {/* old hint={pool.purchased > 0 ? `incl. ${pool.purchased} added` : undefined} /> */}
                            <Stat label="Assignments this month" value={`${pool.used} / ${pool.limit}`} tone={pool.limit > 0 && pool.available === 0 ? "warn" : "default"}
                                  hint={pool.purchased > 0 ? splitOf(key, pool) : undefined} />
                            <Stat label="Available" value={pool.available} />
                            <Stat label="Next month" value={pool.availableNextMonth} hint="available" />
                        </div>
                        {pool.limit > 0 && pool.available === 0 && (
                            <p className={`mt-4 flex items-start gap-2 text-sm ${s.text}`}>
                                <AlertTriangle size={16} className="mt-0.5 flex-shrink-0 text-amber-500" />
                                <span>
                                    {/* old All {key} licenses are in use this month. */}
                                    All {LICENSE_TYPE_LABEL[key]} licenses are in use this month.
                                    {/* old {key === "student" && studentOptions.length > 0 && ` ${studentOptions.length} student${studentOptions.length === 1 ? " on your roster doesn't" : "s on your roster don't"} have one.`} */}
                                    {key === "student" && studentOptions.length > 0 && ` ${studentOptions.length} client${studentOptions.length === 1 ? " on your roster doesn't" : "s on your roster don't"} have one.`}
                                </span>
                            </p>
                        )}
                        {/* old {pool.limit === 0 ? ( */}
                        {/* (assigning is in the table below now: the Assign button in each person's row) */}
                        {pool.limit === 0 && (
                            //old <p className={`mt-4 text-sm ${s.muted}`}>Your plan doesn't include {key} licenses yet.</p>
                            <p className={`mt-4 text-sm ${s.muted}`}>Your plan doesn't include {LICENSE_TYPE_LABEL[key]} licenses yet.</p>
                        )}
                        {/* old ) : ( */}
                        {/* old     <div className="mt-4 flex flex-col gap-2 sm:flex-row"> */}
                        {/* old         <select aria-label={`Assign a ${key} license`} className={s.input} value={pick} onChange={(e) => setPick(e.target.value)} */}
                        {/* old                 disabled={options.length === 0}> */}
                        {/* old             <option value=""> */}
                        {/* old                 {options.length === 0 ? emptyHint : pool.available === 0 ? "No new licenses left this month" : `Choose a ${key}…`} */}
                        {/* old             </option> */}
                        {/* old             {options.map((m) => { */}
                        {/* old                 const canReuse = reusable.has(`${key}:${optionValue(m)}`); */}
                        {/* old                 return ( */}
                        {/* old                     <option key={optionValue(m)} value={optionValue(m)} disabled={pool.available === 0 && !canReuse}> */}
                        {/* old                         {optionLabel(m)}{canReuse ? " (restore this month's license)" : ""} */}
                        {/* old                     </option> */}
                        {/* old                 ); */}
                        {/* old             })} */}
                        {/* old         </select> */}
                        {/* old         <button type="button" className={s.btnPrimary} */}
                        {/* old                 disabled={!pick || busy || (pool.available === 0 && !reusable.has(`${key}:${pick}`))} */}
                        {/* old                 onClick={() => assign(key, pick)}> */}
                        {/* old             Assign */}
                        {/* old         </button> */}
                        {/* old     </div> */}
                        {/* old )} */}
                        {/* old <Plan plan={plans[key]} pricing={requests.pricing[key]} busy={busy} canEdit={isPlatformAdmin} */}
                        {/* (the number and renewal change in the Licenses window: Change licenses below) */}
                        {/* old <Plan plan={plans[key]} pricing={requests.pricing[key]} busy={busy} canEdit={false} bizbrand={isPlatformAdmin} */}
                        {/* (its licenses said the Licenses window's way: 50 student licenses (25 free + 25 paid)) */}
                        <Plan plan={plans[key]} pricing={requests.pricing[key]} busy={busy} canEdit={false} bizbrand={isPlatformAdmin}
                              orgType={org?.OrgType} base={pool.base} added={addedOf(key)}
                              onChangeSeats={changeSeats} onAutoRenew={setAutoRenew} />
                        {/* old <RequestMore kind={key} pricing={requests.pricing[key]} busy={busy} plan={plans[key]} canRequest={isPlatformAdmin} */}
                        <RequestMore kind={key} pricing={requests.pricing[key]} busy={busy} plan={plans[key]} canRequest={isPlatformAdmin}
                                     orgType={org?.OrgType} base={pool.base} added={addedOf(key)}
                                     bizbrand={isPlatformAdmin}
                                     open={requests.requests.find((r) => r.LicenseType === key && (r.Status === "pending" || r.Status === "approved"))}
                                     onCreate={createRequest} onCancel={cancelRequest} onPay={payRequest} />
                        {/* Pono Pilot changes the number and renewal in the Licenses window, whatever is waiting here */}
                        {isPlatformAdmin && (
                            <button type="button" className={`mt-4 ${s.btnSecondary}`} onClick={() => setLicensesOpen(true)}>
                                <KeyRound size={14} /> Change licenses
                            </button>
                        )}
                    </Panel>
                ))}
            </div>

            {/* This month's licenses as one table, under the cards (Alicia, Oct 30: "a spreadsheet-like licenses page with a
                key, an assignee, an Assign button and sorting by assigned status") */}
            <Panel title={`Licenses this month (${licenseCount})`} padded={false}
                   actions={rows.length > 0 && (
                       <select aria-label="Sort" value={sort} onChange={(e) => setSort(e.target.value)} className={`${s.input} md:w-56`}>
                           {LICENSE_SORTS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                       </select>
                   )}>
                {nobodyLines.length + savedLines.length > 0 && (
                    <div className="space-y-2 px-5 pt-4">
                        {nobodyLines.concat(savedLines).map((line) => (
                            <p key={line.key} className={`flex items-start gap-2 text-sm ${line.warn ? (s.dark ? "text-amber-300" : "text-amber-700") : s.body}`}>
                                {line.warn ? <AlertTriangle size={16} className="mt-0.5 flex-shrink-0 text-amber-500" />
                                    : <Info size={16} className={`mt-0.5 flex-shrink-0 ${s.muted}`} />}
                                <span>{line.text}</span>
                            </p>
                        ))}
                    </div>
                )}
                {/* nobody in it (no licenses and nobody without one): licenses left with nobody to give them to say so, and why
                    is in the lines above */}
                {rows.length === 0 ? (
                    <EmptyState icon={KeyRound} title={licenseCount > 0 ? "Nobody to assign a license to yet" : "No licenses this month"} />
                ) : (
                    <LicenseGrid rows={rows} summary={summary} busy={busy} onRemove={revoke} pools={pools}
                                 picked={picked} onToggle={(key) => { setNudge(false); setPicked((prev) => ({ ...prev, [key]: !prev[key] })); }}
                                 onRestore={(type, who) => assignPicks([{ type, value: who }], { keepPicks: true })} />
                )}
                {/* The one button (JJ, Nov 2; the Career Success Index's way: its count next to it, live): the picks
                    given at once while they fit the licenses left, otherwise more are bought first (picking more people
                    than there are licenses left is how more are bought) */}
                {/* It stays at the bottom of the screen while the table scrolls, and sits in its own place once the table's end
                    is in view (JJ, Nov 2: with a long roster it was screens down): sticky, on the panel's background with its top
                    border so the rows don't show through, rounded as the panel's bottom is, and clear of a phone's bottom safe area
                    (its height is kept clear for what Tab moves to: above) */}
                <div ref={setBar} className={`sticky bottom-0 z-10 flex flex-wrap items-center justify-end gap-3 rounded-b-2xl border-t px-5 pt-4 ${s.dark ? "border-slate-700 bg-slate-800" : "border-slate-100 bg-white"}`}
                     style={{ paddingBottom: "calc(1rem + env(safe-area-inset-bottom))" }}>
                    {/* Assign licenses clicked with nobody picked: where to pick, on a line of its own above it; with no Assign in any
                        row (nobody without a license, or everyone without one waiting for a request's licenses) it says there's
                        nobody to pick, and why is in the lines above the table (review, Nov 2) */}
                    {nudge && !pickedList.length && (
                        <p role="status" className={`basis-full text-sm sm:text-right ${s.dark ? "text-amber-300" : "text-amber-700"}`}>
                            {personRows.some((r) => !r.waiting) ? "Press Assign next to whoever gets a license first." : "Nobody to assign a license to yet."}
                        </p>
                    )}
                    <span className={`text-sm font-bold uppercase tracking-wide ${over.length ? (s.dark ? "text-amber-400" : "text-amber-600") : s.muted}`}>
                        {counts.length ? counts.map((c) => `${c.type === "coach" ? "Coaches" : "Clients"}: ${c.n} picked, ${c.left} left`).join(" · ") : "Nobody picked yet"}
                    </span>
                    {buyType ? (
                        <button type="button" className={s.btnPrimary} disabled={busy} onClick={() => setBuying(buyType)}>Buy more licenses</button>
                    ) : (
                        <button type="button" className={s.btnPrimary} disabled={busy} onClick={assignAll}>
                            {busy && <Loader2 size={14} className="animate-spin" />}Assign licenses
                        </button>
                    )}
                </div>
            </Panel>

            {requests.requests.length > 0 && (
                //old <Panel title="License requests" padded={false}>
                <Panel title="History" padded={false}>
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead>
                                <tr className={`border-b ${s.dark ? "border-slate-700" : "border-slate-100"}`}>
                                    <th className={s.th}>Requested</th>
                                    <th className={s.th}>Licenses</th>
                                    <th className={s.th}>Price</th>
                                    <th className={s.th}>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {requests.requests.map((r) => (
                                    <tr key={r.RequestID} className={`border-b last:border-0 ${s.row}`}>
                                        <td className={`${s.td} whitespace-nowrap`}>{formatDate(r.CreatedOn)}</td>
                                        <td className={s.td}>
                                            {/* old {r.Quantity} {r.LicenseType === "coach" ? "coach" : "student"} */}
                                            {r.Quantity} {r.LicenseType === "coach" ? "coach" : "client"}
                                            {r.RenewsRequestID && <span className={`ml-1 text-xs ${s.muted}`}>(renewal)</span>}
                                        </td>
                                        <td className={`${s.td} whitespace-nowrap tabular-nums`}>
                                            {/* old {r.TotalAmount != null ? <>{money(r.TotalAmount)} {perPeriod(r.BillingMode)}</> : <span className={s.muted}>Set by Pono Pilot</span>} */}
                                            {/* (seats added to a plan can cost nothing more, never a negative amount) */}
                                            {r.TotalAmount != null ? (Number(r.TotalAmount) > 0 ? <>{money(r.TotalAmount)} {perPeriod(r.BillingMode)}</> : "No extra cost")
                                                : <span className={s.muted}>Set by Pono Pilot</span>}
                                            {r.ScheduledQuantity != null && (
                                                <div className={`text-xs ${s.muted}`}>
                                                    {r.Status === "active" ? `from next renewal (${r.ScheduledQuantity} licenses)` : `for ${r.ScheduledQuantity} licenses`}
                                                </div>
                                            )}
                                        </td>
                                        <td className={s.td}>
                                            {/* old <Pill tone={(REQUEST_STATUS[r.Status] || {}).tone}>{(REQUEST_STATUS[r.Status] || {}).label || r.Status}</Pill> */}
                                            {/* waiting for payment but it can't be paid anymore (its price changed since it was set up, or its Pay by
                                                day is over), as the box above says: not Ready to pay */}
                                            {r.Status === "approved" && (r.QuoteChanged || r.PayByPassed)
                                                ? <Pill tone="warning">Can't be paid</Pill>
                                                : <Pill tone={(REQUEST_STATUS[r.Status] || {}).tone}>{(REQUEST_STATUS[r.Status] || {}).label || r.Status}</Pill>}
                                            {r.Status === "rejected" && r.ReviewNote && <div className={`mt-1 text-xs ${s.muted}`}>{r.ReviewNote}</div>}
                                            {(r.Status === "active" || r.Status === "ended") && r.EndPeriod && <div className={`mt-1 text-xs ${s.muted}`}>Through {formatMonth(r.EndPeriod)}</div>}
                                            {r.Status === "active" && r.StartPeriod && !r.EndPeriod && r.RenewsRequestID && <div className={`mt-1 text-xs ${s.muted}`}>From {formatMonth(r.StartPeriod)}</div>}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Panel>
            )}

            {/* (the table before the one above: assigned licenses only, under History) */}
            {
            //old <Panel title={`Licenses this month (${summary.licenses.length})`} padded={false}>
            //old     {summary.licenses.length === 0 ? (
            //old         <EmptyState icon={KeyRound} title="No licenses assigned this month" body="Assign coach and student licenses above." />
            //old     ) : (
            //old         <div className="relative overflow-x-auto">
            //old             <table className="w-full">
            //old                 <thead>
            //old                     <tr className={`border-b ${s.dark ? "border-slate-700" : "border-slate-100"}`}>
            //old                         <th className={s.th}>Name</th>
            //old                         <th className={s.th}>Type</th>
            //old                         <th className={s.th}>Code</th>
            //old                         <th className={s.th}>Assigned</th>
            //old                         <th className={s.th}>Status</th>
            //old                         <th className={s.th}><span className="sr-only">Actions</span></th>
            //old                     </tr>
            //old                 </thead>
            //old                 <tbody>
            //old                     {summary.licenses.map((l) => (
            //old                         <tr key={l.LicenseID} className={`border-b last:border-0 ${s.row}`}>
            //old                             <td className={s.td}>
            //old                                 <div className={`font-semibold ${s.text}`}>{l.FirstName} {l.LastName}</div>
            //old                                 {/* old <div className={`text-xs ${s.muted}`}>{l.Email}</div> */}
            //old                                 <div className={`text-xs ${s.muted} [overflow-wrap:anywhere]`}>
            //old                                     {l.RosterID}{l.RosterID && (l.Email || l.EmailAddress) ? " · " : ""}
            //old                                     {(l.Email || l.EmailAddress) && <EmailText email={l.Email || l.EmailAddress} />}
            //old                                 </div>
            //old                             </td>
            //old                             <td className={s.td}><Pill tone={l.LicenseType === "coach" ? "primary" : "neutral"}>{l.LicenseType === "coach" ? "Coach" : "Student"}</Pill></td>
            //old                             <td className={s.td}>
            //old                                 {!l.LicenseCode ? <span className={s.muted}>—</span> : (
            //old                                     <div className="flex flex-col items-start gap-1">
            //old                                         {/* a removed license's code no longer works, so there's nothing to copy */}
            //old                                         {l.IsActive
            //old                                             ? <span className="whitespace-nowrap"><InviteCode code={l.LicenseCode} /></span>
            //old                                             : <span className={`whitespace-nowrap font-mono text-sm line-through ${s.muted}`}>{l.LicenseCode}</span>}
            //old                                         {!!l.IsActive && <span className={`text-xs ${s.muted}`}>{l.LicenseRedeemed ? "Joined" : "Not redeemed yet"}</span>}
            //old                                     </div>
            //old                                 )}
            //old                             </td>
            //old                             <td className={`${s.td} whitespace-nowrap`}>{formatDate(l.AssignedOn)}</td>
            //old                             <td className={s.td}>
            //old                                 {!l.IsActive
            //old                                     ? <Pill tone="warning">Removed · seat frees {formatDate(summary.nextPeriod)}</Pill>
            //old                                     : l.EndPeriod
            //old                                         ? <Pill tone="warning">Ends {formatDate(summary.periodEnd)} · not enough licenses next month</Pill>
            //old                                         : <Pill tone="success">Active</Pill>}
            //old                             </td>
            //old                             <td className={`${s.td} text-right`}>
            //old                                 {!!l.IsActive && <button type="button" className={s.btnDanger} disabled={busy} onClick={() => revoke(l)}>Remove</button>}
            //old                             </td>
            //old                         </tr>
            //old                     ))}
            //old                 </tbody>
            //old             </table>
            //old         </div>
            //old     )}
            //old </Panel>
            }
            {buying && (
                <BuyMoreDialog orgId={orgId} kind={buying} left={summary[buying].available} pricing={requests.pricing[buying]} plan={plans[buying]}
                               picks={pickedList.filter((p) => p.type === buying)}
                               onClose={() => setBuying(null)} onSent={(quantity) => onRequestSent(buying, quantity)} />
            )}
            {licensesOpen && (
                <LicensesModal orgId={orgId} onClose={() => setLicensesOpen(false)}
                               onChanged={() => Promise.all([load(), loadRequests(), reloadOrg()])} />
            )}
            {adding && (
                <AddToPlanDialog orgId={orgId} orgType={org?.OrgType} req={adding} base={summary[adding.LicenseType]?.base || 0}
                                 added={addedOf(adding.LicenseType)} plan={plans[adding.LicenseType]}
                                 onClose={() => setAdding(null)}
                                 onPaid={async () => {
                                     setAdding(null);
                                     //old setNotice(`${adding.Quantity} ${adding.LicenseType} licenses added to your plan. They're ready to assign.`);
                                     setNotice(`${adding.Quantity} ${LICENSE_TYPE_LABEL[adding.LicenseType]} licenses added to your plan. They're ready to assign.`);
                                     await Promise.all([load(), loadRequests(), reloadOrg()]);
                                 }} />
            )}
        </div>
    );
}


/** The Licenses table's orders (?sort=), worded as the Students page's Sort; the first is the default. */
const LICENSE_SORTS = [
    { value: "unassigned", label: "Sort: not assigned first" },
    { value: "assigned", label: "Sort: assigned first" },
    { value: "alpha", label: "Sort: A–Z" },
    { value: "type", label: "Sort: by type" },
    { value: "newest", label: "Sort: newest first" },
];
/** The table's rows in a LICENSE_SORTS order. Ties keep the rows' own order: the licenses as the backend lists them (coach
 *  first, active before removed, by last name), then the people without one: the coaches (as Coaches & Admins lists them),
 *  then the clients (the roster's A–Z). Not assigned first puts the people who can be picked first, then the people waiting
 *  for a More licenses request's licenses, then the licenses, and assigned first the other way round, as in the mock JJ chose
 *  (Nov 2). A–Z puts everyone together by the name the table shows; by type puts the people without a license before the
 *  licenses within each type; newest first goes by when a license was given, and the people without one, who have no date,
 *  come after the licenses. */
function sortLicenseRows(rows, sort) {
    const free = (r) => (r.license ? 1 : 0); // someone without a license: 0
    const status = (r) => (r.license ? 2 : r.waiting ? 1 : 0); // someone who can be picked: 0, waiting: 1
    const coach = (r) => (r.type === "coach" ? 0 : 1);
    const name = (r) => personName(r.license || r.person).toLowerCase();
    const when = (r) => (r.license ? Date.parse(r.license.AssignedOn) || 0 : 0);
    const by = {
        unassigned: (a, b) => status(a) - status(b),
        assigned: (a, b) => status(b) - status(a),
        alpha: (a, b) => name(a).localeCompare(name(b)),
        type: (a, b) => coach(a) - coach(b) || free(a) - free(b),
        newest: (a, b) => free(b) - free(a) || when(b) - when(a),
    }[sort];
    return rows.map((r, i) => [r, i]).sort(([a, i], [b, j]) => by(a, b) || i - j).map(([r]) => r);
}

/**
 * This month's licenses, one row each (coach and client together, a removed one until its seat frees on the 1st), and a
 * row for everyone who could get one and doesn't have one: License code (clients only), Name, Type, Status, Since, and the
 * row's action. The cells of a license are the ones the table had before, but when a removed one's seat frees (and why one
 * ends) goes under its pill, so the table still fits a 1280 window with the big Assign buttons.
 * Someone without a license has a big Assign button (JJ, Nov 2: no lists, a big button people just press): it picks them
 * for the one button under the table, and pressed again it unpicks them; a picked row is lightly highlighted. Someone saved
 * with a More licenses request whose licenses aren't there yet waits for them instead (Waiting for licenses, no button).
 * A removed license has Restore while its person can have it back (on its own seat, so also when none are left).
 * On a phone (below sm) the License code and action columns are hidden, and a row's code and action go under its name
 * instead (JJ, Nov 2: the button under the name), so every row's button shows without scrolling the table sideways.
 */
function LicenseGrid({ rows, summary, busy, onRemove, pools, picked, onToggle, onRestore }) {
    const s = useOrgStyles();
    // Six columns in a portal page: the cells are a little tighter, as the Students grid's, so the whole table fits a
    // 1280 window (a phone has four, the code and the action under the name, and scrolls the rest sideways in its panel)
    const th = s.th.replace("px-4", "px-3");
    const td = s.td.replace("px-4", "px-3");
    const poolOf = (type) => pools.find((p) => p.key === type);
    // The Assign button, bigger than the table's other buttons: outlined in the brand blue, filled once pressed (Picked)
    const pickButton = (on) => `inline-flex min-w-[8.5rem] items-center justify-center gap-1.5 whitespace-nowrap rounded-xl border-2 px-5 py-2 text-sm font-semibold transition-colors disabled:opacity-50 ${on
        ? "border-primary-600 bg-primary-600 text-white hover:border-primary-700 hover:bg-primary-700"
        : s.dark ? "border-primary-400 text-primary-300 hover:bg-primary-900/40" : "border-primary-300 bg-white text-primary-700 hover:border-primary-500 hover:bg-primary-50"}`;
    // The small line under a name: RosterID · email (someone added by email alone has their email as the name line, so it
    // isn't repeated here) · not joined yet, for someone on the roster without a license who hasn't joined (as the list said)
    const subLine = (m, invited) => [m.RosterID, (m.FirstName || m.LastName) && (m.Email || m.EmailAddress) && <EmailText key="email" email={m.Email || m.EmailAddress} />,
        invited && "not joined yet"].filter(Boolean).flatMap((part, i) => (i ? [" · ", part] : [part]));
    return (
        <div className="relative overflow-x-auto">
            <table className="w-full">
                <thead>
                    <tr className={`border-b ${s.dark ? "border-slate-700" : "border-slate-100"}`}>
                        <th className={`${th} hidden sm:table-cell`}>License code</th>
                        <th className={th}>Name</th>
                        <th className={th}>Type</th>
                        <th className={th}>Status</th>
                        <th className={th}>Since</th>
                        <th className={`${th} hidden sm:table-cell`}><span className="sr-only">Actions</span></th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => {
                        const l = row.license;
                        const p = poolOf(row.type);
                        // a removed license's person as the table keys them, and whether they can have it back (they're still one of
                        // its type's people without a license)
                        const who = l && (l.LicenseType === "coach" ? String(l.AdminID) : studentKey(l));
                        const canRestore = l && !l.IsActive && p.options.some((m) => String(p.optionValue(m)) === who);
                        // whose row it is: the license's person, or someone without one (picked: pressed Assign)
                        const person = l || row.person;
                        const on = !l && !row.waiting && !!picked[row.key];
                        // a license's code (a client's), with whether it was used; in its own column, or under the name on a phone
                        const code = l && l.LicenseCode && (
                            <div className="flex flex-col items-start gap-1">
                                {/* a removed license's code no longer works, so there's nothing to copy */}
                                {l.IsActive
                                    ? <span className="whitespace-nowrap"><InviteCode code={l.LicenseCode} /></span>
                                    : <span className={`whitespace-nowrap font-mono text-sm line-through ${s.muted}`}>{l.LicenseCode}</span>}
                                {!!l.IsActive && <span className={`text-xs ${s.muted}`}>{l.LicenseRedeemed ? "Joined" : "Not redeemed yet"}</span>}
                            </div>
                        );
                        // the row's action, in the last column or under the name on a phone: someone without a license has Assign,
                        // which picks them for the button under the table (JJ, Nov 2), and someone saved with a request waits for its
                        // licenses; a license has Remove, a removed one Restore
                        const action = !l ? (row.waiting ? <span className={`whitespace-nowrap text-xs ${s.muted}`}>Saved with your request</span> : (
                            <button type="button" aria-pressed={on} aria-label={`Assign a license to ${personName(person)}`} className={pickButton(on)}
                                    disabled={busy} onClick={() => onToggle(row.key)}>
                                {on ? <><Check size={16} /> Picked</> : "Assign"}
                            </button>
                        ))
                            : l.IsActive ? <button type="button" className={s.btnDanger} disabled={busy} onClick={() => onRemove(l)}>Remove</button>
                                : canRestore && <button type="button" className={s.btnSm} disabled={busy} onClick={() => onRestore(p.key, who)}>Restore</button>;
                        return (
                            <tr key={row.key} className={`border-b last:border-0 ${on ? (s.dark ? "border-slate-700 bg-primary-900/30" : "border-slate-100 bg-primary-50") : s.row}`}>
                                <td className={`${td} hidden sm:table-cell`}>{code || <span className={s.muted}>—</span>}</td>
                                {/* wide enough for a name on one line; a long email wraps */}
                                <td className={`${td} min-w-[10rem]`}>
                                    {/* someone added by email alone has no name yet: their email is the name line, not repeated under it */}
                                    <div className={`font-semibold ${s.text} [overflow-wrap:anywhere]`}>
                                        {person.FirstName || person.LastName ? `${person.FirstName} ${person.LastName}` : <EmailText email={person.Email || person.EmailAddress || ""} />}
                                    </div>
                                    <div className={`text-xs ${s.muted} [overflow-wrap:anywhere]`}>
                                        {subLine(person, !l && row.type === "student" && person.Status === "invited")}
                                    </div>
                                    {/* on a phone the code and the action go under the name (JJ, Nov 2), so every row's button shows
                                        without scrolling the table sideways */}
                                    {(code || action) && <div className="mt-2 flex flex-col items-start gap-2 sm:hidden">{code}{action}</div>}
                                </td>
                                <td className={td}><Pill tone={row.type === "coach" ? "primary" : "neutral"}>{row.type === "coach" ? "Coach" : "Client"}</Pill></td>
                                <td className={td}>
                                    {/* (when a removed license's seat frees, and why one ends, go under the pill, so the column stays narrow
                                        enough for the table to fit, also with the big Assign buttons) */}
                                    {!l ? (row.waiting ? <Pill tone="primary">Waiting for licenses</Pill> : <Pill>Not assigned</Pill>)
                                        : !l.IsActive ? <><Pill tone="warning">Removed</Pill><div className={`mt-1 whitespace-nowrap text-xs ${s.muted}`}>Seat frees {formatDate(summary.nextPeriod)}</div></>
                                            : l.EndPeriod ? <><Pill tone="warning">Ends {formatDate(summary.periodEnd)}</Pill><div className={`mt-1 text-xs ${s.muted}`}>Not enough licenses next month</div></>
                                                : <Pill tone="success">Active</Pill>}
                                </td>
                                <td className={`${td} whitespace-nowrap`}>{l ? formatDate(l.AssignedOn) : <span className={s.muted}>—</span>}</td>
                                <td className={`${td} hidden text-right sm:table-cell`}>{action}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}


/**
 * Buy more licenses (JJ, Nov 2): the picks of one license type are more than the licenses left, so more are asked for,
 * here on the Licenses page, with choices only, nothing to write: how many (clients 25 / 50 / 100, coaches 10 / 25 / 50,
 * the first chosen, or a number typed in), each with its price the way the Licenses window shows a package's, and Send
 * request. It makes a "More licenses" request with the picks saved on it (Build My Biz Brand approves it on Change
 * requests); nobody is assigned now. plan: the org's plan for these licenses, if it has one (they'd be added to it).
 */
function BuyMoreDialog({ orgId, kind, left, pricing, plan, picks, onClose, onSent }) {
    const s = useOrgStyles();
    const choices = kind === "coach" ? [10, 25, 50] : [25, 50, 100];
    const label = LICENSE_TYPE_LABEL[kind];
    const [text, setText] = useState(String(choices[0]));
    const [sending, setSending] = useState(false);
    const [error, setError] = useState("");
    const typed = /^\d+$/.test(text.trim()) ? Number(text.trim()) : null;
    const quantity = typed != null && typed >= 1 && typed <= 1000 ? typed : null;
    const need = picks.length - left;
    // What n more cost (Pay now), or add to the plan's bill (Add to my plan), as the set-up will price them
    const planSeats = plan ? Number(plan.ScheduledQuantity ?? plan.Quantity) : 0;
    const cost = (n) => (!pricing ? null : plan ? Math.max(0, quote(pricing, planSeats + n).total - Number(plan.TotalAmount || 0)) : quote(pricing, n).total);
    const price = (n) => (cost(n) == null ? null : `${plan ? "+" : ""}${money(cost(n))} ${per(pricing.BillingMode)}`);

    const send = async () => {
        setSending(true);
        setError("");
        try {
            await api.post(`/org/${orgId}/change-requests`, {
                featureName: "more_licenses", licenseType: kind, quantity,
                picks: picks.map(({ value }) => (kind === "coach" ? { adminId: Number(value) }
                    : value.startsWith("e") ? { rosterEntryId: Number(value.slice(1)) } : { clientId: Number(value.slice(1)) })),
            });
            await onSent(quantity);
        } catch (err) {
            setError(apiError(err));
            setSending(false);
        }
    };

    return (
        <OrgModal isOpen onClose={sending ? () => {} : onClose} title={`Buy more ${label} licenses`}
                  footer={<>
                      <button type="button" className={s.btnSecondary} disabled={sending} onClick={onClose}>Cancel</button>
                      <button type="button" className={s.btnPrimary} disabled={!quantity || sending} onClick={send}>
                          {sending && <Loader2 size={14} className="animate-spin" />}Send request
                      </button>
                  </>}>
            <Alert onClose={() => setError("")}>{error}</Alert>
            <div className={`space-y-4 text-sm ${s.body}`}>
                <p>
                    You picked {picks.length} {picks.length === 1 ? "person" : "people"} and have {left} {label} license{left === 1 ? "" : "s"} left.
                </p>
                <div className="grid gap-2 sm:grid-cols-3" role="group" aria-label="How many more licenses">
                    {choices.map((n) => {
                        const on = typed === n;
                        return (
                            <button key={n} type="button" aria-pressed={on} disabled={sending} onClick={() => setText(String(n))}
                                    className={`rounded-xl border-2 p-3 text-left transition-colors disabled:opacity-50 ${on
                                        ? (s.dark ? "border-primary-400 bg-primary-900/30" : "border-primary-500 bg-primary-50")
                                        : (s.dark ? "border-slate-600 hover:border-slate-500" : "border-slate-200 hover:border-slate-300")}`}>
                                <span className={`block font-bold ${s.text}`}>{n} licenses</span>
                                {price(n) && <span className={`block text-xs ${s.muted}`}>{price(n)}</span>}
                            </button>
                        );
                    })}
                </div>
                <div className="flex flex-wrap items-center gap-2">
                    <label htmlFor="buy-more-number" className={s.body}>Or another number:</label>
                    <input id="buy-more-number" type="number" min="1" max="1000" disabled={sending} value={text}
                           onChange={(e) => setText(e.target.value)} className={`${s.input} !w-24`} />
                    {quantity && !choices.includes(quantity) && price(quantity) && <span className={s.muted}>{price(quantity)}</span>}
                </div>
                {!quantity && <p role="status" className={s.dark ? "text-amber-300" : "text-amber-700"}>Enter a number from 1 to 1000.</p>}
                {quantity && quantity < need && (
                    <p role="status" className={s.dark ? "text-amber-300" : "text-amber-700"}>
                        That's fewer than you picked: {need} more cover everyone you picked.
                    </p>
                )}
                {/* (the request form's words for what happens next) */}
                {!pricing && <p className={s.muted}>Pono Pilot will confirm the price when they review your request.</p>}
                <p className={`text-xs ${s.muted}`}>
                    {pricing ? "Nothing is charged now. Once your request is approved, you pay here and the licenses are added right away, with the people you picked filled in, ready to assign."
                        : "Nothing is charged here. Once Pono Pilot approves your request, the licenses are added right away, with the people you picked filled in, ready to assign."}
                </p>
            </div>
        </OrgModal>
    );
}


/**
 * Add to my plan asks first, the way Google Workspace, Microsoft 365 and Zoom show what's due today and the
 * new total before they charge for more licenses: today's charge to the card on the plan for the rest of this
 * billing period (Stripe's own preview of the change, less any credit) and what the plan renews at. Pay charges
 * that amount: the change is priced as of the moment shown (an hour later it's shown again first).
 * plan: the plan they're added to, whose renewal may be off (then they end with it, nothing renews).
 */
function AddToPlanDialog({ orgId, orgType, req, base, added, plan, onClose, onPaid }) {
    const s = useOrgStyles();
    const [preview, setPreview] = useState(null);
    const [error, setError] = useState("");
    const [paying, setPaying] = useState(false);

    const loadPreview = useCallback(async () => {
        setPreview(null);
        try {
            const res = await api.get(`/org/${orgId}/license-requests/${req.RequestID}/preview`);
            setPreview(res.data);
            return true;
        } catch (err) {
            setError(apiError(err, "We couldn't get today's amount. Try again in a minute."));
            return false;
        }
    }, [orgId, req.RequestID]);
    useEffect(() => { loadPreview(); }, [loadPreview]);

    const pay = async () => {
        setPaying(true);
        setError("");
        try {
            await api.post(`/org/${orgId}/license-requests/${req.RequestID}/checkout`,
                { prorationDate: preview.prorationDate, seats: preview.seats });
            await onPaid();
        } catch (err) {
            // priced too long ago, or the plan changed since: nothing was charged, so show the amount again first
            if (err?.response?.data?.code === "PREVIEW_EXPIRED") {
                if (await loadPreview()) setError("The amount was out of date, so here it is again. Check it, then pay.");
            } else {
                setError(apiError(err, "The payment didn't go through."));
            }
            setPaying(false);
        }
    };

    const today = Number(preview?.today || 0);
    return (
        //old <OrgModal isOpen onClose={paying ? () => {} : onClose} title={`Add ${req.Quantity} ${req.LicenseType} licenses to your plan?`}
        <OrgModal isOpen onClose={paying ? () => {} : onClose} title={`Add ${req.Quantity} ${LICENSE_TYPE_LABEL[req.LicenseType]} licenses to your plan?`}
                  footer={<>
                      <button type="button" className={s.btnSecondary} disabled={paying} onClick={onClose}>Not now</button>
                      <button type="button" className={s.btnPrimary} disabled={!preview || paying} onClick={pay}>
                          {paying ? <Loader2 size={14} className="animate-spin" /> : <CreditCard size={14} />}
                          {" "}{!preview || today > 0 ? `Pay ${preview ? money(today) : ""}`.trim() : "Add to my plan"}
                      </button>
                  </>}>
            <Alert onClose={() => setError("")}>{error}</Alert>
            {!preview ? (
                !error && (
                    <div className="space-y-2" aria-busy="true">
                        {[0, 1].map((i) => <Skeleton key={i} height={56} borderRadius={12}
                                                     baseColor={s.dark ? "#334155" : "#e2e8f0"} highlightColor={s.dark ? "#475569" : "#f1f5f9"} />)}
                    </div>
                )
            ) : (
                <div className={`space-y-3 text-sm ${s.body}`}>
                    <div className={`rounded-xl border p-3 ${s.subPanel}`}>
                        <p>
                            Today: <strong className={s.text}>{today > 0 ? money(today) : "nothing to pay"}</strong>
                        </p>
                        <p className={`mt-1 text-xs ${s.muted}`}>
                            {today > 0
                                ? `Charged now to the card on your plan, for the rest of this billing period${preview.periodEnd ? ` (until ${formatDate(preview.periodEnd)})` : ""}.`
                                : "Nothing is charged today."}
                            {Number(preview.credit) > 0 && ` ${money(preview.credit)} of credit on your account is used first.`}
                        </p>
                    </div>
                    <div className={`rounded-xl border p-3 ${s.subPanel}`}>
                        <p>
                            {/* old Then: <strong className={s.text}>{base + added + preview.seats} {req.LicenseType} licenses ({licenseParts(orgType, base, added, preview.seats)})</strong>, */}
                            Then: <strong className={s.text}>{base + added + preview.seats} {LICENSE_TYPE_LABEL[req.LicenseType]} licenses ({licenseParts(orgType, base, added, preview.seats)})</strong>,
                            {" "}<strong className={s.text}>{money(preview.total)} {per(preview.billingMode)}</strong>
                        </p>
                        <p className={`mt-1 text-xs ${s.muted}`}>
                            {/* (its renewal stopped under Manage billing: they end with the plan, the day its row says) */}
                            {plan?.CancelAtPeriodEnd
                                ? `Renewal is off: these licenses end with your plan ${plan.CurrentPeriodEnd ? `on ${formatDate(monthEnd(plan.CurrentPeriodEnd))}` : "when this period ends"}.`
                                : <>
                                    {req.TierName ? `Your ${req.TierName} plan` : "Your plan"} renews at that price{preview.periodEnd ? ` on ${formatDate(preview.periodEnd)}` : ""}.
                                    {" "}You can cancel anytime under Manage billing.
                                </>}
                        </p>
                    </div>
                </div>
            )}
        </OrgModal>
    );
}


/**
 * "Request more licenses": a Pono Pilot admin asks for seats here (or
 * sets them up from Admin → Organizations), then the org admin pays here. Price
 * comes from the group pricing on the tier their licenses give (set in
 * Membership Management → Edit Tier). Org admins can't ask for a number
 * themselves; they still pay for or cancel an open request.
 */
//old function RequestMore({ kind, pricing, plan, open, busy, canRequest, onCreate, onCancel, onPay }) {
// bizbrand: a Pono Pilot admin, who changes the number in the Licenses window instead of asking for seats here
//old function RequestMore({ kind, pricing, plan, open, busy, canRequest, onCreate, onCancel, onPay, bizbrand }) {
// orgType, base, added: for what the org has once these are added, the Licenses window's way (100 in all (25 free + 75 paid))
function RequestMore({ kind, pricing, plan, open, busy, canRequest, onCreate, onCancel, onPay, bizbrand, orgType, base = 0, added = 0 }) {
    const s = useOrgStyles();
    // licenses and plans are asked for on the Requests page, where the org sees what happened (Evan, Oct 16)
    const { goTo } = useOrgPortal();
    const askLink = <button type="button" className={s.btnLink} onClick={() => goTo("requests", { feature: "other" })}>send us a request</button>;
    const [show, setShow] = useState(false);
    const [qty, setQty] = useState(5);
    const [note, setNote] = useState("");
    const quantity = Math.max(1, Math.min(1000, parseInt(qty, 10) || 0));
    // With a plan, the discount follows the plan's new total (every seat gets it)
    const planSeats = plan ? (plan.ScheduledQuantity ?? plan.Quantity) : 0;
    const q = pricing ? quote(pricing, planSeats + quantity) : null;
    const period = perPeriod(pricing?.BillingMode);
    const inAll = (paid) => <>, <strong className={s.text}>{base + added + paid}</strong> in all ({licenseParts(orgType, base, added, paid)})</>;

    if (open) {
        // past its Pay by day it can't be paid anymore: the box doesn't open with Ready to pay above the sentence
        // saying so (History says Can't be paid)
        const expired = open.Status === "approved" && !open.QuoteChanged && !!open.PayByPassed;
        return (
            <div className={`mt-4 rounded-xl border p-3 text-sm ${s.subPanel}`}>
                {open.Status === "pending" ? (
                    //old <p className={s.body}>Your request for <strong className={s.text}>{open.Quantity}</strong> {kind} licenses is waiting for Pono Pilot's approval.</p>
                    <p className={s.body}>Your request for <strong className={s.text}>{open.Quantity}</strong> {LICENSE_TYPE_LABEL[kind]} licenses is waiting for Pono Pilot's approval.</p>
                ) : open.QuoteChanged && open.AddsToPlan && plan?.PlanChangeBlocked ? (
                    // for a plan whose own price, discount or billing changed since it was bought: nothing can be added to it
                    // before it ends, so they can't be set up again either (that's refused); the org declines them and asks
                    // about its licenses, Pono Pilot cancels it and changes the number once the plan has ended
                    <p className={s.body}>
                        {/* old Set up for you: <strong className={s.text}>{open.Quantity}</strong> more {kind} licenses. */}
                        Set up for you: <strong className={s.text}>{open.Quantity}</strong> more {LICENSE_TYPE_LABEL[kind]} licenses.
                        {" "}{PLAN_BLOCKED[plan.PlanChangeBlocked] || PLAN_BLOCKED.PRICE_CHANGED}, so licenses can't be added to it.
                        {" "}{bizbrand ? "Cancel the request. To change the number, stop its renewal with Change licenses, then set up new licenses once it ends."
                            : <>Decline them. To change your licenses, {askLink}.</>}
                    </p>
                ) : open.QuoteChanged ? (
                    // their price changed since they were set up (a discount step in Edit Tier): paying would charge more
                    // (or, for a first purchase, the price in Edit Tier; a plan's own price is the case above):
                    // paying them is refused, so it says why and what to do instead
                    <p className={s.body}>
                        {/* old Set up for you: <strong className={s.text}>{open.Quantity}</strong> more {kind} licenses, but their price changed since */}
                        Set up for you: <strong className={s.text}>{open.Quantity}</strong> more {LICENSE_TYPE_LABEL[kind]} licenses, but their price changed since
                        {" "}Pono Pilot set them up, so they can't be {open.AddsToPlan ? "added" : "paid for"} at that price.
                        {" "}{bizbrand ? "Cancel the request, then set them up again with Change licenses." : <>Decline them and {askLink} to set them up again.</>}
                    </p>
                ) : open.AddsToPlan ? (
                    <p className={s.body}>
                        {/* old Approved: <strong className={s.text}>{open.Quantity}</strong> more {kind} licenses */}
                        {/* old {expired ? "Set up for you" : Number(open.TotalAmount) > 0 ? "Ready to pay" : "Ready to add"}: <strong className={s.text}>{open.Quantity}</strong> more {kind} licenses */}
                        {expired ? "Set up for you" : Number(open.TotalAmount) > 0 ? "Ready to pay" : "Ready to add"}: <strong className={s.text}>{open.Quantity}</strong> more {LICENSE_TYPE_LABEL[kind]} licenses
                        {/* old {open.TotalAmount != null && <> (+<strong className={s.text}>{money(open.TotalAmount)}</strong> {perPeriod(open.BillingMode)})</>}. */}
                        {/* (an add priced as what it adds to the plan's bill can cost nothing more) */}
                        {open.TotalAmount != null && (Number(open.TotalAmount) > 0
                            //old ? <> (+<strong className={s.text}>{money(open.TotalAmount)}</strong> {perPeriod(open.BillingMode)})</> : <> at no extra cost</>)}.
                            ? <> (+<strong className={s.text}>{money(open.TotalAmount)}</strong> {per(open.BillingMode)})</> : <> at no extra cost</>)}{inAll(planSeats + Number(open.Quantity))}.
                        {/* old {" "}Adding them charges the card on your plan for the rest of this billing period; after that they're billed with your plan. */}
                        {!expired && <>{" "}Adding them charges the card on your plan for the rest of this billing period; after that they're billed with your plan.</>}
                    </p>
                ) : open.RenewsRequestID ? (
                    // a renewal the org started with Renew and didn't pay for yet: the paid licenses it has, not more
                    <p className={s.body}>
                        {/* old {expired ? "Renewal" : "Ready to pay: renewal"} of your <strong className={s.text}>{open.Quantity}</strong> paid {kind} licenses */}
                        {expired ? "Renewal" : "Ready to pay: renewal"} of your <strong className={s.text}>{open.Quantity}</strong> paid {LICENSE_TYPE_LABEL[kind]} licenses
                        {open.TotalAmount != null && <> for <strong className={s.text}>{money(open.TotalAmount)}</strong> {per(open.BillingMode)}</>}{inAll(Number(open.Quantity))}.
                    </p>
                ) : (
                    <p className={s.body}>
                        {/* old Approved: <strong className={s.text}>{open.Quantity}</strong> {kind} licenses */}
                        {/* old {open.TotalAmount != null && <> for <strong className={s.text}>{money(open.TotalAmount)}</strong> {perPeriod(open.BillingMode)}</>}. */}
                        {/* old {expired ? "Set up for you" : "Ready to pay"}: <strong className={s.text}>{open.Quantity}</strong> more {kind} licenses */}
                        {expired ? "Set up for you" : "Ready to pay"}: <strong className={s.text}>{open.Quantity}</strong> more {LICENSE_TYPE_LABEL[kind]} licenses
                        {open.TotalAmount != null && <> for <strong className={s.text}>{money(open.TotalAmount)}</strong> {per(open.BillingMode)}</>}{inAll(Number(open.Quantity))}.
                    </p>
                )}
                {/* its Pay by day is over: paying is refused, so it says what to do instead */}
                {open.Status === "approved" && !open.QuoteChanged && !!open.PayByPassed && (
                    <p className={`mt-1 ${s.dark ? "text-amber-300" : "text-amber-700"}`}>
                        These had to be paid for by {formatDate(open.PayBy)}, so they can't be paid anymore.
                        {" "}{bizbrand ? "Cancel the request, then set them up again with Change licenses." : <>Decline them and {askLink} to set them up again.</>}
                    </p>
                )}
                <div className="mt-2 flex flex-wrap gap-2">
                    {/* old {open.Status === "approved" && ( */}
                    {open.Status === "approved" && !open.QuoteChanged && !open.PayByPassed && (
                        <button type="button" className={s.btnPrimary} disabled={busy} onClick={() => onPay(open)}>
                            <CreditCard size={14} /> {open.AddsToPlan ? "Add to my plan" : "Pay now"}
                        </button>
                    )}
                    {/* the day to pay by, the date the emails say too */}
                    {open.Status === "approved" && !open.QuoteChanged && !open.PayByPassed && open.PayBy && (
                        <span className={`self-center text-xs ${s.muted}`}>{Number(open.TotalAmount) > 0 ? "Pay" : "Add them"} by {formatDate(open.PayBy)}</span>
                    )}
                    {/* old <button type="button" className={s.btnSecondary} disabled={busy} onClick={() => onCancel(open)}>Cancel request</button> */}
                    {/* the org declines licenses Pono Pilot set up; an older request of its own or a renewal it started
                        (or Pono Pilot's set-up, for Pono Pilot reading) is cancelled */}
                    <button type="button" className={s.btnSecondary} disabled={busy} onClick={() => onCancel(open)}>
                        {open.Status === "approved" && !bizbrand && !open.RenewsRequestID ? "Decline" : "Cancel request"}
                    </button>
                </div>
            </div>
        );
    }

    // One place to change the number (more, fewer, renewal): the Licenses window (Change licenses, below)
    if (bizbrand) return null;

    if (!canRequest) {
        //old return <p className={`mt-4 text-sm ${s.muted}`}>Pono Pilot sets up your licenses. Contact us to change them.</p>;
        return <p className={`mt-4 text-sm ${s.muted}`}>Pono Pilot sets up your licenses. To change them, {askLink}.</p>;
    }

    if (!show) {
        return (
            <button type="button" className={`mt-4 ${s.btnLink}`} onClick={() => setShow(true)}>
                {/* old Need more {kind} licenses? */}
                Need more {LICENSE_TYPE_LABEL[kind]} licenses?
            </button>
        );
    }

    return (
        <form className={`mt-4 space-y-3 rounded-xl border p-3 ${s.subPanel}`}
              onSubmit={async (e) => {
                  e.preventDefault();
                  if (await onCreate(kind, quantity, note)) { setShow(false); setNote(""); }
              }}>
            <Field label="How many more?" htmlFor={`req-${kind}`}>
                <input id={`req-${kind}`} type="number" min="1" max="1000" className={s.input} value={qty} onChange={(e) => setQty(e.target.value)} />
            </Field>
            {q && plan ? (
                <p className={`text-sm ${s.body}`}>
                    Your plan goes from {planSeats} to <strong className={s.text}>{planSeats + quantity}</strong> licenses at{" "}
                    {money(q.each)} each{q.pct > 0 && <> ({pctText(q.pct)} off)</>}: <strong className={s.text}>{money(q.total)}</strong> {period}.
                    <span className={`block text-xs ${s.muted}`}>When you add them, you pay for the rest of this billing period only.</span>
                    {pricing.Discounts.length > 0 && (
                        <span className={`block text-xs ${s.muted}`}>
                            Volume discounts: {pricing.Discounts.map((d) => `${d.MinQuantity}+ = ${pctText(d.PercentOff)} off`).join(" · ")}
                        </span>
                    )}
                </p>
            ) : q ? (
                <p className={`text-sm ${s.body}`}>
                    {money(pricing.UnitPrice)} per license{q.pct > 0 && <>, <strong className={s.text}>{pctText(q.pct)} off</strong> for {quantity}</>}:{" "}
                    <strong className={s.text}>{money(q.total)}</strong> {period}.
                    {pricing.Discounts.length > 0 && (
                        <span className={`block text-xs ${s.muted}`}>
                            Volume discounts: {pricing.Discounts.map((d) => `${d.MinQuantity}+ = ${pctText(d.PercentOff)} off`).join(" · ")}
                        </span>
                    )}
                </p>
            ) : (
                <p className={`text-sm ${s.muted}`}>Pono Pilot will confirm the price when they review your request.</p>
            )}
            <Field label="Note (optional)" htmlFor={`req-note-${kind}`}>
                <textarea id={`req-note-${kind}`} rows={2} maxLength={500} className={s.input} value={note} onChange={(e) => setNote(e.target.value)} />
            </Field>
            <p className={`text-xs ${s.muted}`}>
                {pricing
                    ? `Nothing is charged now. Once your request is approved, you pay here and the licenses are added right away. They renew automatically ${period.replace("per ", "every ")}.`
                    : "Nothing is charged here. Once Pono Pilot approves your request, the licenses are added right away."}
            </p>
            <div className="flex gap-2">
                <button type="submit" className={s.btnPrimary} disabled={busy}>Send request</button>
                <button type="button" className={s.btnSecondary} onClick={() => setShow(false)}>Cancel</button>
            </div>
        </form>
    );
}


/**
 * Stripe's customer portal for a plan: change the card it's paid with, see and
 * download invoices, pay one that failed, or cancel (at the end of the paid
 * period, like a student's own membership). An org's own admins can.
 */
function ManageBilling({ plan }) {
    const s = useOrgStyles();
    const { orgId } = useOrgPortal();
    const [opening, setOpening] = useState(false);
    const [error, setError] = useState("");

    // Back (the browser's button) from Stripe restores this page as it was: let the button work again
    useEffect(() => {
        const restored = (e) => { if (e.persisted) setOpening(false); };
        window.addEventListener("pageshow", restored);
        return () => window.removeEventListener("pageshow", restored);
    }, []);

    const open = async () => {
        setOpening(true);
        setError("");
        try {
            const res = await api.post(`/org/${orgId}/license-requests/${plan.RequestID}/billing`);
            window.location.assign(res.data.url);
        } catch (err) {
            setError(apiError(err, "We couldn't open billing. Try again."));
            setOpening(false);
        }
    };

    return (
        <div className="mt-2 flex flex-wrap items-center gap-2 text-xs">
            <button type="button" className={s.btnSm} disabled={opening} onClick={open}>
                {opening ? <Loader2 size={12} className="animate-spin" /> : <CreditCard size={12} />} Manage billing
            </button>
            <span className={s.muted}>Change the card, see invoices or cancel.</span>
            {error && <span role="alert" className={s.dark ? "text-red-300" : "text-red-600"}>{error}</span>}
        </div>
    );
}

/**
 * The org's plan for a license type, like a team plan in other apps: seats
 * renew automatically; fewer seats take effect at the next renewal; renewal
 * can be stopped (the paid period keeps its seats). Only Pono Pilot
 * admins (canEdit) change the seats or renewal; org admins see the plan.
 */
//old function Plan({ plan, pricing, busy, canEdit, onChangeSeats, onAutoRenew }) {
// bizbrand: a Pono Pilot admin is reading, who changes the plan with Change licenses (not Manage billing)
//old function Plan({ plan, pricing, busy, canEdit, onChangeSeats, onAutoRenew, bizbrand }) {
// orgType, base, added: its licenses said the Licenses window's way, "50 student licenses (25 free + 25 paid)"
function Plan({ plan, pricing, busy, canEdit, onChangeSeats, onAutoRenew, bizbrand, orgType, base = 0, added = 0 }) {
    const s = useOrgStyles();
    const [editing, setEditing] = useState(false);
    const [seats, setSeats] = useState("");
    if (!plan) return null;
    const next = plan.ScheduledQuantity ?? plan.Quantity;
    const renewsOn = plan.CurrentPeriodEnd ? formatDate(plan.CurrentPeriodEnd) : null;
    // The saved price is what the next renewal bills. With fewer seats scheduled,
    // this period's price is for today's number of seats.
    const scheduled = plan.ScheduledQuantity != null;
    const nowQuote = scheduled && pricing ? quote(pricing, plan.Quantity) : null;

    return (
        <div className={`mt-4 rounded-xl border p-3 text-sm ${s.subPanel}`}>
            <div className="flex flex-wrap items-baseline justify-between gap-2">
                {/* old <span className={`font-semibold ${s.text}`}>Your plan: {plan.Quantity} licenses</span> */}
                {/* (the free or included ones too, so 25 paid on top of 25 free reads as 50, not 25) */}
                <span className={`font-semibold ${s.text}`}>
                    {/* old Your plan: {base + added + Number(plan.Quantity)} {plan.LicenseType} licenses ({licenseParts(orgType, base, added, plan.Quantity)}) */}
                    Your plan: {base + added + Number(plan.Quantity)} {LICENSE_TYPE_LABEL[plan.LicenseType]} licenses ({licenseParts(orgType, base, added, plan.Quantity)})
                </span>
                {nowQuote ? (
                    //old <span className={s.body}>{money(nowQuote.total)} {perPeriod(plan.BillingMode)}{nowQuote.pct > 0 && ` (${pctText(nowQuote.pct)} off)`}</span>
                    <span className={s.body}>{money(nowQuote.total)} {per(plan.BillingMode)}{nowQuote.pct > 0 && ` (${pctText(nowQuote.pct)} off)`}</span>
                ) : !scheduled && (
                    //old <span className={s.body}>{money(plan.TotalAmount)} {perPeriod(plan.BillingMode)}{Number(plan.PercentOff) > 0 && ` (${pctText(plan.PercentOff)} off)`}</span>
                    <span className={s.body}>{money(plan.TotalAmount)} {per(plan.BillingMode)}{Number(plan.PercentOff) > 0 && ` (${pctText(plan.PercentOff)} off)`}</span>
                )}
            </div>
            <p className={`mt-1 text-xs ${s.muted}`}>
                {plan.CancelAtPeriodEnd
                    ? (renewsOn
                        ? `Renewal is off: the licenses end on ${formatDate(monthEnd(plan.CurrentPeriodEnd))}. `
                            //old + (canEdit ? `Turn it back on by ${renewsOn} to keep them.` : `To keep them, contact Pono Pilot by ${renewsOn}.`)
                            // (an org's own admins renew in Stripe's portal, where they cancelled)
                            //old + (canEdit ? `Turn it back on by ${renewsOn} to keep them.` : `To keep them, renew under Manage billing by ${renewsOn}.`)
                            + (bizbrand ? `Turn it back on with Change licenses by ${renewsOn} to keep them.` : `To keep them, renew under Manage billing by ${renewsOn}.`)
                        : "Renewal is off: the licenses end when this period ends.")
                    //old : `Renews automatically${renewsOn ? ` on ${renewsOn}` : ""}.`}
                    // and, for the org's own admins, that they can cancel anytime (Manage billing)
                    : `Renews automatically${renewsOn ? ` on ${renewsOn}` : ""}.`
                        //old + (canEdit ? "" : " You can cancel anytime under Manage billing and keep the licenses until then.")}
                        + (bizbrand ? " Change it with Change licenses below." : " You can cancel anytime under Manage billing and keep the licenses until then.")}
                {scheduled && !plan.CancelAtPeriodEnd &&
                    //old ` From then on: ${plan.ScheduledQuantity} licenses, ${money(plan.TotalAmount)} ${perPeriod(plan.BillingMode)}${Number(plan.PercentOff) > 0 ? ` (${pctText(plan.PercentOff)} off)` : ""}.`}
                    //old ` From then on: ${base + added + Number(plan.ScheduledQuantity)} ${plan.LicenseType} licenses (${licenseParts(orgType, base, added, plan.ScheduledQuantity)}), `
                    ` From then on: ${base + added + Number(plan.ScheduledQuantity)} ${LICENSE_TYPE_LABEL[plan.LicenseType]} licenses (${licenseParts(orgType, base, added, plan.ScheduledQuantity)}), `
                    + `${money(plan.TotalAmount)} ${per(plan.BillingMode)}${Number(plan.PercentOff) > 0 ? ` (${pctText(plan.PercentOff)} off)` : ""}.`}
            </p>
            <ManageBilling plan={plan} />
            {!canEdit ? null : editing ? (
                <form className="mt-2 flex flex-wrap items-center gap-2"
                      onSubmit={(e) => { e.preventDefault(); onChangeSeats(plan, Number(seats)); setEditing(false); }}>
                    <label htmlFor={`seats-${plan.RequestID}`} className={`text-xs ${s.muted}`}>Licenses from the next renewal</label>
                    <input id={`seats-${plan.RequestID}`} type="number" min="1" max={plan.Quantity} required
                           className={`${s.input} max-w-[6rem]`} value={seats} onChange={(e) => setSeats(e.target.value)} />
                    <button type="submit" className={s.btnSm} disabled={busy}>Save</button>
                    <button type="button" className={s.btnSm} onClick={() => setEditing(false)}>Cancel</button>
                    <span className={`basis-full text-xs ${s.muted}`}>
                        Fewer licenses start at the next renewal; you keep all {plan.Quantity} until then and aren't refunded. To add licenses, send a request below.
                    </span>
                </form>
            ) : (
                <div className="mt-2 flex flex-wrap gap-2">
                    {!plan.CancelAtPeriodEnd && (
                        <button type="button" className={s.btnSm} disabled={busy} onClick={() => { setSeats(String(next)); setEditing(true); }}>
                            Use fewer licenses
                        </button>
                    )}
                    <button type="button" className={s.btnSm} disabled={busy} onClick={() => onAutoRenew(plan, !!plan.CancelAtPeriodEnd)}>
                        {plan.CancelAtPeriodEnd ? "Turn renewal back on" : "Stop renewing"}
                    </button>
                </div>
            )}
        </div>
    );
}
